<template>
  <div v-if="show">
         <stepheader :step="step"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <label class="form-label" for="imei">Imei: <span class="tx-danger">*</span></label>
              <input v-model="imei" class="form-control" id="imei" name="imei" placeholder="inserisci imei" required="" type="text" >
            </div>
            <div class="col-md-6 col-lg-6">
              <label class="form-label" for="vatnumber">Card Number: <span class="tx-danger">*</span></label>
              <input  v-model="cardnumber" class="form-control" id="cardnumber" name="vatnumber" placeholder="card number" required="" type="text">
            </div>
          </div>
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
  </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "loginbusiness",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      imei:"111111111111090",
      cardnumber:"SR-638173201052271090",
      templates: [],
      wizard: {},
      usersteps: [],
      show:true
    };
  },
  computed: {
    cuser() {
      return { roles: [] };
    },
    tinyKey: function () {
      return window.TinyApiKey;
    },
  },
  components: {
   
  },
  mounted() {
    if(localStorage.getItem("srwizardtoken")){
      this.show=false;
axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem("srwizardtoken")}`;
this.$emit("loadTicket","infodevice");

    }
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        case "next":
            this.authenticate(nextstep);
          break;

      }

    },
  

    authenticate:function(nextstep){
axios.post("auth",{username:this.cardnumber, password:this.imei}).then(response=>{
axios.defaults.headers['Authorization'] = `Bearer ${response.data.token}`;
localStorage.setItem("srwizardtoken",response.data.token)

this.$emit("loadTicket",nextstep);

}).catch(e => {
 swal({
              title: "Errore di autenticazione",
              text: "Non riconosco le informazioni e",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });

});
 
    }
  },
};
</script>